// src/utils/request.js
import { API_BASE_URL, API_CONTENT_TYPE, API_REQUEST_METHODS } from '@/constants/api'

/**
 * 统一封装 fetch 请求
 * @param {string} url - 请求路径（相对 API_BASE_URL）
 * @param {object} options - fetch 请求配置（method, headers, body 等）
 * @returns {Promise<any>}
 */
const request = async (url, options = {}) => {

    const fullUrl = API_BASE_URL + url
    // 请求方法
    let method = options.method
    // Content-Type，POST才设置，默认 application/x-www-form-urlencoded
    let contentType = options.contentType
    if (method == API_REQUEST_METHODS.POST && !options.contentType) {
        contentType = API_CONTENT_TYPE.APPLICATION_FORM
    }
    // 默认采用 GET 请求
    if (method == undefined || method == '') {
        method = API_REQUEST_METHODS.GET
    }
    const token = localStorage.getItem('token')
    const headers = method == API_REQUEST_METHODS.POST ? {
        'Content-Type': contentType,
        'token': token,
        'source': '4',  // web
        'version': '1.0.35',
    } : {
        'token': token,
        'source': '4',  // web
        'version': '1.0.35',
    }

    const config = {
        method: method,
        headers: headers,
        ...options,
    }

    // JSON 请求需要转 body 数据
    if (config.body && typeof config.body === 'object') {
        if (contentType == API_CONTENT_TYPE.APPLICATION_JSON) {
            config.body = JSON.stringify(config.body)
        } else if (contentType === API_CONTENT_TYPE.APPLICATION_FORM) {
            const urlSearchParams = new URLSearchParams()
            for (const key in config.body) {
                urlSearchParams.append(key, config.body[key])
            }
            config.body = urlSearchParams.toString()
        }
    }

    try {
        const response = await fetch(fullUrl, config)

        console.log('===============================================================================================')
        console.log('==    接口地址: ' + url);
        console.log('==    接口Header: ' + JSON.stringify(headers));
        console.log('==    接口参数: ' + JSON.stringify(config.body));
        console.log('==    请求类型: ' + method);
        console.log("==    接口状态: " + response.status);
        console.log('===============================================================================================')

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}))
            throw new Error(errorData.message || `HTTP error! status: ${response.status}`)
        }

        // 根据返回类型处理
        const data = await response.json()
        if (data.code != 200) {
            if (data.code == 3004) {
                // token失效或不可用，触发全局重新登录事件
                console.log('token失效或不可用')
                window.dispatchEvent(new CustomEvent('auth-login-required', { detail: { msg: data.msg || '登录失效或不可用，请重新登录' } }))
                const err = new Error(data.msg || 'Token expired')
                err.code = data.code
                throw err
            }
            // 触发全局API错误事件，使用弹窗提示
            window.dispatchEvent(new CustomEvent('global-api-error', { detail: { msg: data.msg } }))
            const err = new Error(data.msg || `Data error! status: ${data.code}`)
            err.code = data.code
            throw err
        }
        console.log('接口结果: ' + JSON.stringify(data.data));
        return data.data
    } catch (error) {
        console.error('Request error:', error)
        throw error
    }
}

export default request